import { render, staticRenderFns } from "./detail-rebond-modal.vue?vue&type=template&id=12e10b56&scoped=true"
import script from "./detail-rebond-modal.vue?vue&type=script&lang=js"
export * from "./detail-rebond-modal.vue?vue&type=script&lang=js"
import style0 from "./detail-rebond-modal.vue?vue&type=style&index=0&id=12e10b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e10b56",
  null
  
)

export default component.exports